import React from 'react'
import { withSiteData } from 'react-static'

export default withSiteData(() => (
  <div style={{ textAlign: 'center' }}>
    <h1>Willkommen auf der Seite der Familie Schreiner</h1>
  </div>
))
